import { render, staticRenderFns } from "./ModalMakerInfo.vue?vue&type=template&id=6c639bbc&scoped=true"
import script from "./ModalMakerInfo.vue?vue&type=script&lang=js"
export * from "./ModalMakerInfo.vue?vue&type=script&lang=js"
import style0 from "./ModalMakerInfo.vue?vue&type=style&index=0&id=6c639bbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c639bbc",
  null
  
)

export default component.exports